(() => {
  'use strict';
  const modal = document.getElementById('mrv-cart-quickview');
  const stringsNode = document.getElementById('mrv-qv-strings');
  if (!modal || !stringsNode || typeof modal.showModal !== 'function') return;
  const strings = JSON.parse(stringsNode.textContent);
  const $ = selector => modal.querySelector(selector);
  const photos = $('.mrv-qv__photos');
  const cache = new Map();
  let active = null, version = 0, frame = 0;
  const money = cents => new Intl.NumberFormat(strings.locale, {
    style: 'currency', currency: strings.currency, currencyDisplay: 'narrowSymbol', minimumFractionDigits: Number(cents) % 100 ? 2 : 0
  }).format(Number(cents) / 100).replace(/R[\s\u00a0]+(?=\d)/g, 'R');

  // Keep storefront descriptions inert: text and formatting, never scripts or navigation.
  function description(html) {
    const parsed = new DOMParser().parseFromString(html || '', 'text/html');
    const allowed = new Set(['P', 'UL', 'OL', 'LI', 'STRONG', 'B', 'EM', 'I', 'BR', 'H2', 'H3', 'H4', 'BLOCKQUOTE']);
    const blocked = new Set(['SCRIPT', 'STYLE', 'IFRAME', 'OBJECT', 'EMBED', 'FORM', 'SVG', 'TEMPLATE', 'NOSCRIPT']);
    function copy(node) {
      if (node.nodeType === Node.TEXT_NODE) return document.createTextNode(node.textContent);
      const fragment = document.createDocumentFragment();
      if (blocked.has(node.nodeName)) return fragment;
      const output = allowed.has(node.nodeName) ? document.createElement(node.nodeName === 'H2' ? 'h3' : node.nodeName.toLowerCase()) : fragment;
      node.childNodes.forEach(child => output.append(copy(child)));
      return output;
    }
    return copy(parsed.body);
  }

  function imageURL(source) {
    try {
      const url = new URL(source, location.origin);
      if (url.protocol !== 'https:' || !(url.hostname === location.hostname || url.hostname === 'cdn.shopify.com')) return '';
      url.searchParams.set('width', '600');
      return url.href;
    } catch (_) { return ''; }
  }
  function gallery(sources, title) {
    const urls = [...new Set(sources.map(imageURL).filter(Boolean))];
    photos.replaceChildren();
    photos.scrollLeft = 0;
    urls.forEach((url, index) => {
      const image = new Image();
      image.src = url;
      image.alt = strings.photo.replace('__PRODUCT__', title).replace('__NUMBER__', String(index + 1));
      image.width = image.height = 600;
      image.loading = index ? 'lazy' : 'eager';
      image.decoding = 'async';
      const slide = document.createElement('div');
      slide.className = 'mrv-qv__slide';
      slide.append(image);
      photos.append(slide);
    });
    $('.mrv-qv__gallery').hidden = !urls.length;
    $('.mrv-qv__navigation').hidden = urls.length < 2;
    updatePosition();
  }
  function updatePosition() {
    const count = photos.children.length;
    const index = Math.max(0, Math.min(count - 1, Math.round(photos.scrollLeft / (photos.clientWidth || 1))));
    $('.mrv-qv__counter').textContent = count ? `${index + 1} / ${count}` : '';
    $('[data-qv-prev]').disabled = index <= 0;
    $('[data-qv-next]').disabled = index >= count - 1;
  }
  function move(step) {
    const index = Math.round(photos.scrollLeft / (photos.clientWidth || 1));
    photos.scrollTo({ left: (index + step) * photos.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }
  photos.addEventListener('scroll', () => {
    if (frame) return;
    frame = requestAnimationFrame(() => { frame = 0; updatePosition(); });
  }, { passive: true });
  photos.addEventListener('keydown', event => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    move(event.key === 'ArrowRight' ? 1 : -1);
  });
  $('[data-qv-prev]').addEventListener('click', () => move(-1));
  $('[data-qv-next]').addEventListener('click', () => move(1));

  async function getProduct(handle) {
    if (cache.has(handle)) return cache.get(handle);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    const root = window.Shopify?.routes?.root || '/';
    const request = fetch(`${root}products/${encodeURIComponent(handle)}.js`, {
      headers: { Accept: 'application/json' }, signal: controller.signal
    }).then(response => {
      if (!response.ok) throw new Error('Product unavailable');
      return response.json();
    }).then(product => {
      if (product.handle !== handle || !Array.isArray(product.variants)) throw new Error('Invalid product');
      return product;
    }).catch(error => { cache.delete(handle); throw error; }).finally(() => clearTimeout(timeout));
    cache.set(handle, request);
    return request;
  }
  async function load() {
    const current = active, token = ++version;
    $('.mrv-qv__status').textContent = strings.loading;
    $('[data-qv-retry]').hidden = true;
    try {
      const product = await getProduct(current.handle);
      if (token !== version || !modal.open) return;
      const variant = product.variants.find(item => String(item.id) === current.variant);
      $('#mrv-qv-title').textContent = product.title;
      $('.mrv-qv__variant').textContent = variant && variant.title !== 'Default Title' ? variant.title : '';
      $('.mrv-qv__variant').hidden = !$('.mrv-qv__variant').textContent;
      $('.mrv-qv__price').textContent = variant ? money(variant.price) : '';
      $('.mrv-qv__status').textContent = variant && !variant.available ? strings.unavailable : '';
      const copy = description(product.description);
      $('.mrv-qv__description').replaceChildren(copy);
      if (!$('.mrv-qv__description').textContent.trim()) $('.mrv-qv__description').textContent = strings.empty;
      $('.mrv-qv__about').hidden = false;
      // Merchant gallery convention: Black Friday hero first, original hero last.
      const images = (product.images || []).filter(source => !source.includes('/mirova-cart-'));
      gallery(images.length > 1 ? [images[images.length - 1], ...images.slice(1, -1)] : [], product.title);
    } catch (_) {
      if (token !== version || !modal.open) return;
      $('.mrv-qv__status').textContent = strings.error;
      $('[data-qv-retry]').hidden = false;
    }
  }
  function open(link) {
    const card = link.closest('.mrv-bf-offer');
    const handle = link.dataset.mrvQuickview;
    if (!card || !/^[a-z0-9-]+$/.test(handle)) return;
    const scroll = document.querySelector('cart-drawer .cart-drawer-items-and-upsell');
    const track = card.closest('.mrv-bf-offers__track');
    active = { link, handle, variant: card.querySelector('[name="id"]')?.value || '',
      scrollTop: scroll?.scrollTop || 0, scrollLeft: track?.scrollLeft || 0 };
    $('#mrv-qv-title').textContent = link.querySelector('span')?.textContent || '';
    $('.mrv-qv__variant').hidden = true;
    $('.mrv-qv__price').textContent = '';
    $('.mrv-qv__about').hidden = true;
    $('.mrv-qv__description').replaceChildren();
    gallery([], $('#mrv-qv-title').textContent);
    $('.mrv-qv__gallery').hidden = false;
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
    modal.showModal();
    $('.mrv-qv__scroll').scrollTop = 0;
    $('.mrv-qv__close').focus({ preventScroll: true });
    load();
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('cart-drawer [data-mrv-quickview]');
    if (!link || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    open(link);
  });
  modal.querySelectorAll('[data-qv-close]').forEach(button => button.addEventListener('click', () => modal.close()));
  // Close on keyup so the same Escape cannot reach the restored cart focus.
  modal.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    event.preventDefault();
    event.stopPropagation();
  });
  modal.addEventListener('keyup', event => {
    if (event.key !== 'Escape') return;
    event.stopPropagation();
    modal.close();
  });
  $('[data-qv-retry]').addEventListener('click', load);
  modal.addEventListener('close', () => {
    ++version;
    const previous = active;
    active = null;
    if (!previous) return;
    const drawer = document.querySelector('cart-drawer.active');
    if (!drawer) return;
    const link = previous.link.isConnected ? previous.link : drawer.querySelector(`[data-mrv-quickview="${previous.handle}"]`);
    const focus = link || drawer.querySelector('.drawer__close');
    if (focus && typeof trapFocus === 'function') trapFocus(drawer.querySelector('.drawer__inner'), focus);
    const scroll = drawer.querySelector('.cart-drawer-items-and-upsell');
    const track = drawer.querySelector('.mrv-bf-offers__track');
    if (scroll) scroll.scrollTop = previous.scrollTop;
    if (track) track.scrollLeft = previous.scrollLeft;
  });
})();

